import styled from 'styled-components';

export const LoginStyled = styled.div<{ $wide?: boolean }>`
    position: relative;
    width: 100%;
    max-width: ${({ $wide }) => ($wide ? '480px' : '420px')};
    padding: 32px 28px 36px;
    background: var(--color-surface);
    border: 1px solid var(--color-main);
    border-radius: var(--radius-lg);

    .auth-title {
        margin: 0 0 var(--space-2);
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .auth-subtitle {
        margin: 0 0 28px;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }

    .auth-actions {
        display: grid;
        gap: var(--space-3);
        margin-top: var(--space-6);
    }

    .auth-error {
        margin: 0 0 var(--space-4);
        font-size: var(--font-size-md);
        color: var(--color-negative);
    }
`;

export const LoginBoxAcceptTermsContainerStyled = styled.div`
    font-weight: 400;

    .form-check .form-check-input[type='checkbox'].is-invalid {
        border-color: var(--color-negative);
    }

    .form-check-input.is-invalid ~ .form-check-label {
        color: var(--text-color-secondary);
    }
`;

export const LoginForgotPasswordLinkContainerStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: var(--space-6);
`;
